const INTERMISSION_NAME_PATTERN = /intermission/i
const PHASE_NAME_NUMBER_PATTERN = /(\d+(?:\.\d+)?)/
const NOTE_PHASE_EPSILON = 0.0001

type NamedPhase = {
  name: string
}

export const isIntermissionPhaseName = (name: string) =>
  INTERMISSION_NAME_PATTERN.test(name)

const parseNamedPhaseNumber = (name: string) => {
  const match = name.match(PHASE_NAME_NUMBER_PATTERN)
  if (!match) return null
  const parsed = Number(match[1])
  return Number.isFinite(parsed) ? parsed : null
}

const countMainPhasesThrough = (phases: NamedPhase[], lastIndex: number) => {
  let mainPhaseCount = 0
  for (let index = 0; index <= lastIndex; index += 1) {
    if (!isIntermissionPhaseName(phases[index]?.name ?? '')) {
      mainPhaseCount += 1
    }
  }
  return mainPhaseCount
}

export const toNotePhaseNumber = (phases: NamedPhase[], phaseIndex: number) => {
  const phase = phases[phaseIndex]
  if (!phase) return phaseIndex + 1

  const namedNumber = parseNamedPhaseNumber(phase.name)
  if (isIntermissionPhaseName(phase.name)) {
    if (namedNumber !== null) return namedNumber + 0.5
    for (let index = phaseIndex - 1; index >= 0; index -= 1) {
      const previous = phases[index]
      if (!previous || isIntermissionPhaseName(previous.name)) continue
      const previousNumber = parseNamedPhaseNumber(previous.name)
      if (previousNumber !== null) return previousNumber + 0.5
      return countMainPhasesThrough(phases, index) + 0.5
    }
    return 0.5
  }

  if (namedNumber !== null) return namedNumber
  return countMainPhasesThrough(phases, phaseIndex)
}

export const formatNotePhaseNumber = (phaseNumber: number) => {
  if (Number.isInteger(phaseNumber)) return String(phaseNumber)
  return String(Math.round(phaseNumber * 10) / 10)
}

export const fromNotePhaseNumber = (phases: NamedPhase[], phaseRaw: number) => {
  const matchIndex = phases.findIndex((_, index) => {
    return (
      Math.abs(toNotePhaseNumber(phases, index) - phaseRaw) < NOTE_PHASE_EPSILON
    )
  })
  if (matchIndex >= 0) return matchIndex

  if (!Number.isInteger(phaseRaw)) return null
  const sequentialIndex = phaseRaw - 1
  if (sequentialIndex < 0 || sequentialIndex >= phases.length) return null
  return sequentialIndex
}
